var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"progress-status border"},[_c('patient-over-h-n-progress-tabs'),_c('div',{staticClass:"my-5 pa-5"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }